// extracted by mini-css-extract-plugin
export default {"client":"Client_client__zSmMp","userName":"Client_userName__D1Xzn"};